import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { supabase } from "@/integrations/supabase/client";

export const MetaTags = () => {
  const [settings, setSettings] = useState({
    meta_description:
      "Računovodski servis, ki razume tvojo pot – od prvega računa do prvega investitorja.",
    favicon_url: "/favicon.jpg",
  });

  useEffect(() => {
    (async () => {
      const { data, error } = await supabase.functions.invoke(
        "get-public-settings",
      );
      if (!error && data) {
        setSettings((prev) => ({
          meta_description: data.meta_description || prev.meta_description,
          favicon_url: data.favicon_url || prev.favicon_url,
        }));
      }
    })();
  }, []);

  return (
    <Helmet>
      <meta name="description" content={settings.meta_description} />
      <meta property="og:description" content={settings.meta_description} />
      <link rel="icon" href={settings.favicon_url} type="image/jpeg" />
    </Helmet>
  );
};
